import { render, staticRenderFns } from "./Basic.vue?vue&type=template&id=668dd0ff&"
import script from "./Basic.vue?vue&type=script&lang=js&"
export * from "./Basic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\xampp7.4.1\\htdocs\\e2e-invoicing\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('668dd0ff')) {
      api.createRecord('668dd0ff', component.options)
    } else {
      api.reload('668dd0ff', component.options)
    }
    module.hot.accept("./Basic.vue?vue&type=template&id=668dd0ff&", function () {
      api.rerender('668dd0ff', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/views/wizard/mailDriver/Basic.vue"
export default component.exports